import React, { useEffect, useState, useCallback } from 'react';
import Footer from '../Components/Footer';
import Auth from '../Function/Auth';
import Header from '../Components/Header';
import { toast, ToastContainer } from "react-toastify";

function Deposits() {
  const authToken = sessionStorage.getItem('authToken');
  const baseurl = process.env.REACT_APP_BASE_API_URL;
  const [analytics, setAnalytics] = useState([]);
  const [tabelLoading, setTableLoading] = useState(false);
  const [deposits, setDeposits] = useState([]);
  const [pagination, setPagination] = useState([]);
  const [userName, setUserName] = useState("");
  const [txnHash, setTxnHash] = useState("");
  const [txnstatus, setStatus] = useState("");
  const [viewData, setViewData] = useState("");

  const [editPaidAmount, setEditPaidAmount] = useState("");
  const [editFromAddress, setEditFromAddress] = useState("");
  const [editToAddress, setEditToAddress] = useState("");
  const [editTxnHash, setEditTxnHash] = useState("");
  const [editStatus, setEditStatus] = useState("");
  const [deposit_id, setDepositId] = useState([]);
  const [error, setError] = useState("");

  const fetchDepositData = useCallback(async (page = 1) => {
    const searchData = {
      page: page,
      name: userName,
      txnHash: txnHash,
      status: txnstatus,
      txn_hash: txnHash
    };

    try {
      const deposit = await fetch(`${baseurl}/client/deposit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(searchData),
      });

      if (deposit.status === 429) {
        console.error("Rate limit exceeded. Please try again later.");
        return;
      }

      const depositResult = await deposit.json();

      if (depositResult.status) {
        setAnalytics(depositResult.analytics || []);
        setDeposits(depositResult.data || []);
        setPagination(depositResult.pagination || {});
      }
    } catch (err) {
      console.error('Fetch error:', err);
    } finally {
      setTableLoading(true);
    }
  }, [authToken, baseurl, userName, txnHash, txnstatus]);

  useEffect(() => {
    fetchDepositData(1);
  }, [fetchDepositData]);



  const passData = (depositData) => {
    setDepositId(depositData);
    setViewData(depositData);
    setEditPaidAmount(depositData.paid_amount);
    setEditFromAddress(depositData.from_address);
    setEditToAddress(depositData.to_address);
    setEditTxnHash(depositData.txn_hash);
    setEditStatus(depositData.txn_hash);
  };



  const updateDeposit = async () => {

    console.log(editPaidAmount, editFromAddress, editToAddress, editTxnHash, editStatus)

    if (!deposit_id) return setError("Try again.");
    if (!editPaidAmount) return setError("Paid amount id required.");
    if (!editFromAddress) return setError("From address is required");
    if (!editToAddress) return setError("To address is reuired.");
    if (!editTxnHash) return setError("Txn Hash is required.");
    if (!editStatus) return setError("Status is required.");
    if (!authToken) return setError("Authentication is required.");


    const formData = {
      deposit_id: deposit_id.id,
      paid_amount: editPaidAmount,
      from_address: editFromAddress,
      to_address: editToAddress,
      txn_hash: editTxnHash,
      status: editStatus
    };

    console.log("Sending Data:", formData);

    try {
      const response = await fetch(`${baseurl}/client/deposit-update`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json(); // Get raw response
      console.log("Raw API Response:", data); // Log response before parsing


      if (data.status) {
        toast.success(data.message)
        window.location.href = "";
      }
      else {
        toast.error(data.message)

      }
    } catch (error) {
      console.error("Fetch error:", error);
      setError("Network error. Please check your connection and try again.");
      toast.error("Network error. Please check your connection and try again.");
    }
  }


  const handlePageChange = async (page) => {

    setTableLoading(false)
    fetchDepositData(page);
  }

  const searchData = () => {

    setTableLoading(false)
    fetchDepositData(1);
  }
  return (
    <>
      <Header>
        <Auth />
        <div className="main-content app-content" >
          <div className="container-fluid">
            {/* Page Header */}
            <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
              <div>
                <h4 className="mb-0">Deposits!</h4>

              </div>
            </div>
            {/* End Page Header */}

            {/* row */}
            <div className="row">
              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-primary-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">TOTAL DEPOSIT</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {analytics ? analytics.total_no_of_deposit : '0'}

                          </h4>
                          <p className="mb-0 fs-12 text-fixed-white op-7">
                            Deposit Value
                          </p>
                        </div>
                        <span className="float-end my-auto ms-auto">

                          <h5 className="text-fixed-white op-7"> ${Number(analytics ? analytics.total_deposit_value : 0).toFixed(2)}
                          </h5>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline" />
                </div>
              </div>

              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-warning-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">OPEN DEPOSIT</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {analytics ? analytics.total_no_of_open_deposit : '0'}
                          </h4>
                          <p className="mb-0 fs-12 text-fixed-white op-7">
                            Deposit Value
                          </p>
                        </div>
                        <span className="float-end my-auto ms-auto">

                          <h5 className="text-fixed-white op-7"> ${Number(analytics ? analytics.open_value : 0).toFixed(2)}</h5>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline4" />
                </div>
              </div>
              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-danger-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">FAILED DEPOSITS</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {analytics ? analytics.total_no_of_failed_deposit : '0'}
                          </h4>
                          <p className="mb-0 fs-12 text-fixed-white op-7">
                            Deposit Value
                          </p>
                        </div>
                        <span className="float-end my-auto ms-auto">

                          <h5 className="text-fixed-white op-7"> ${Number(analytics ? analytics.failed_value : 0).toFixed(2)}</h5>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline2" />
                </div>
              </div>
              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-success-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">SUCCESS DEPOSITS</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {analytics ? analytics.total_no_of_success_deposit : '0'}
                          </h4>
                          <p className="mb-0 fs-12 text-fixed-white op-7">
                            Deposit Value
                          </p>
                        </div>
                        <span className="float-end my-auto ms-auto">

                          <h5 className="text-fixed-white op-7"> ${Number(analytics ? analytics.deposit_value : 0).toFixed(2)}</h5>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline3" />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 col-lg-12 col-xl-12">
                <div className="card card-table ">
                  <div className="row">



                    <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                      <div className="mt-3 ">
                        <lavel>User Name</lavel>
                        <input type="text" value={userName} onChange={(e) => setUserName(e.target.value)} className="form-control" placeholder="Enter User Name" />
                      </div>
                    </div>

                    <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                      <div className="mt-3 ">
                        <lavel>Txn Hash</lavel>
                        <input type="text" value={txnHash} onChange={(e) => setTxnHash(e.target.value)} className="form-control" placeholder="Enter Txn Hash" />
                      </div>
                    </div>



                    <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                      <div className="mt-3">
                        <label>Status</label>
                        <select className="form-control" value={txnstatus} onChange={(e) => setStatus(e.target.value)}>
                          <option value="all">All</option>
                          <option value="open">Open</option>
                          <option value="pending">Pending</option>
                          <option value="success">Success</option>
                          <option value="failed">Failed</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                      <div className="mt-3 text-end">

                        <button onClick={searchData} className="btn btn-primary btn-block mt-3">Search Data</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* row closed */}

            {/* row opened */}
            <div className="row">
              <div className="col-md-12 col-lg-12 col-xl-12">
                <div className="card card-table">
                  <div className=" card-header p-0 d-flex justify-content-between mt-3">
                    <h3 className="card-title mb-1 text-primary">Deposit History</h3>
                  </div>
                  <div className="table-responsive country-table">
                    {tabelLoading ? (
                      <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >

                        <thead>
                          <tr>
                            <th className="wd-lg-25p">User</th>
                            <th className="wd-lg-25p">User Name</th>
                            <th className="wd-lg-25p">DEPOSIT</th>
                            <th className="wd-lg-25p">ASSET</th>
                            <th className="wd-lg-25p">Date Time</th>
                            <th className="wd-lg-25p">STATUS</th>
                            <th className="wd-lg-25p">ACTION</th>
                          </tr>
                        </thead>

                        <tbody>
                          {deposits.length > 0 ? (
                            deposits.map((depositData, index) => (
                              <tr key={index}>
                                <td> <img className="rounded-circle" width={37} alt={depositData.user_name || 'Profile'} src={depositData.profile_image || 'https://apiuser.ride2luxury.in/images/profileImage/avtarImage-1.avif'} /></td>
                                <td> {depositData.user_name || 'N/A'} </td>
                                <td> {depositData.deposit_amount || '0'} </td>
                                <td> {depositData.deposit_asset || 'N/A'} </td>
                                <td> {depositData.date_time || 'N/A'} </td>
                                <td>
                                  {depositData && depositData.status
                                    ? depositData.status === 'success' ? (
                                      <span className="badge bg-success">success</span>
                                    ) : (
                                      <span className="badge bg-danger">{depositData.status} </span>
                                    ) : 'N/A'}
                                </td>
                                <td>
                                  <button type="button" onClick={() => passData(depositData)} className="btn btn-sm btn-primary" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal">
                                    <i className="fa fa-eye"></i>
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" className="text-center">No Data Found</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    ) : (
                      <div className="text-center">
                        <div className="d-flex justify-content-center mb-4">
                          <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      </div>
                    )}


                  </div>
                  <div className="gridjs-footer">
                    <div className="gridjs-pagination">
                      <div className="gridjs-summary" title="Page summary">Showing <b>{pagination.current_page || 1}</b> to <b>{pagination.per_page || 10}</b> of <b>{pagination.total || 0}</b> results</div>
                      <div className="gridjs-pages text-end">
                        {/* Previous Button */}
                        <button type="button" title="Previous" aria-label="Previous" className={pagination.current_page === 1 ? "disabled" : ""} onClick={() => handlePageChange(pagination.current_page - 1)} disabled={pagination.current_page === 1}> Previous</button>

                        {/* First Page */}
                        <button type="button" className={` ${pagination.current_page === 1 ? "gridjs-currentPage" : ""}`} title="Page 1" aria-label="Page 1" onClick={() => handlePageChange(1)}> 1</button>

                        {/* Ellipsis if needed */}
                        {pagination.current_page > 3 && <span>...</span>}

                        {/* Middle Pages (2 dynamic pages around current) */}
                        {Array.from({ length: 5 }, (_, i) => {
                          const page = pagination.current_page - 2 + i;
                          if (page > 1 && page < pagination.last_page) {
                            return (
                              <button key={page} type="button" className={` ${pagination.current_page === page ? "gridjs-currentPage" : ""}`} title={`Page ${page}`}
                                aria-label={`Page ${page}`} onClick={() => handlePageChange(page)}>
                                {page}
                              </button>
                            );
                          }
                          return null;
                        })}

                        {/* Ellipsis if needed */}
                        {pagination.current_page < pagination.last_page - 2 && <span>...</span>}

                        {/* Last Page */}
                        {pagination.last_page > 1 && (
                          <button type="button" className={` ${pagination.current_page === pagination.last_page ? "gridjs-currentPage" : ""}`} title={`Page ${pagination.last_page}`} aria-label={`Page ${pagination.last_page}`}
                            onClick={() => handlePageChange(pagination.last_page)}>
                            {pagination.last_page}
                          </button>
                        )}

                        {/* Next Button */}
                        <button type="button" title="Next" aria-label="Next" className={pagination.current_page === pagination.last_page ? "disabled" : ""} onClick={() => handlePageChange(pagination.current_page + 1)} disabled={pagination.current_page === pagination.last_page}>
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /row */}

          </div>
        </div>

        <div className="modal fade" id="exampleModal" tabindex="-1"
          aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h6 className="modal-title" id="exampleModalLabel1">Deposit History</h6>
                <button type="button" className="btn-close" data-bs-dismiss="modal"
                  aria-label="Close"></button>
              </div>
              <div className="modal-body">


                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">User Name</b></span>
                  </label>
                  <span className="ms-auto">{viewData.user_name || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">Asset</b></span>
                  </label>
                  <span className="ms-auto">{viewData.deposit_asset || 'N/A'}</span>
                </div>


                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">Deposit Amount</b></span>
                  </label>
                  <span className="ms-auto">{viewData.deposit_amount || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">Paid Amount</b></span>
                  </label>
                  <span className="ms-auto">{viewData.paid_amount || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">From Address</b></span>
                  </label>
                  <span className="ms-auto">
                    {viewData.from_address
                      ? viewData.from_address.slice(0, 10) + '....' + viewData.from_address.slice(-10)
                      : 'N/A'
                    }
                  </span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">To Address</b></span>
                  </label>
                  <span className="ms-auto">
                    {viewData.to_address
                      ? viewData.to_address.slice(0, 10) + '....' + viewData.to_address.slice(-10)
                      : 'N/A'
                    }
                  </span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">Txn Hash</b></span>
                  </label>
                  <span className="ms-auto">
                    <a className="text-primary" href={'https://bscscan.com/tx/' + viewData.txn_hash}>{viewData.txn_hash
                      ? viewData.txn_hash.slice(0, 10) + '....' + viewData.txn_hash.slice(-10)
                      : 'N/A'
                    }</a>
                  </span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">Status</b></span>
                  </label>
                  <span className="ms-auto">
                    {viewData && viewData.status
                      ? viewData.status === 'success' ? (
                        <span className="badge bg-success">success</span>
                      ) : (
                        <span className="badge bg-danger">{viewData.status} </span>
                      ) : 'N/A'
                    }
                  </span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">Date Time</b></span>
                  </label>
                  <span className="ms-auto">
                    {viewData.date_time || 'N/A'}
                  </span>
                </div>


              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-danger"
                  data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>



        <div class="modal fade" id="modaldemo8">
          <div class="modal-dialog modal-dialog-centered text-center" role="document">
            <div class="modal-content modal-content-demo">
              <div class="modal-header">
                <h6 class="modal-title">Edit Deposit</h6><button aria-label="Close" class="btn-close" data-bs-dismiss="modal"></button>
              </div>
              <div className="modal-body">
                <div className="d-flex p-3 border-top">
                  <label>
                    <span><b className="text-primary">Company</b></span>
                  </label>
                  <span className="ms-auto">{viewData.company_name || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label>
                    <span><b className="text-primary">User ID</b></span>
                  </label>
                  <span className="ms-auto">{viewData.client_id || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label>
                    <span><b className="text-primary">User Name</b></span>
                  </label>
                  <span className="ms-auto">{viewData.client_name || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label>
                    <span><b className="text-primary">Asset</b></span>
                  </label>
                  <span className="ms-auto">{viewData.deposit_asset || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label>
                    <span><b className="text-primary">Network</b></span>
                  </label>
                  <span className="ms-auto">{viewData.network_type || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label>
                    <span><b className="text-primary">Deposit Amount</b></span>
                  </label>
                  <span className="ms-auto">{viewData.deposit_amount || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label>
                    <span><b className="text-primary">Paid Amount</b></span>
                  </label>
                  <span className="ms-auto">
                    <input
                      type="text"
                      className="form-control"
                      value={editPaidAmount}
                      onChange={(e) => setEditPaidAmount(e.target.value)}
                    />
                  </span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label>
                    <span><b className="text-primary">From Address</b></span>
                  </label>
                  <span className="ms-auto">
                    <input
                      type="text"
                      className="form-control"
                      value={editFromAddress}
                      onChange={(e) => setEditFromAddress(e.target.value)}
                    />
                  </span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label>
                    <span><b className="text-primary">To Address</b></span>
                  </label>
                  <span className="ms-auto">
                    <input
                      type="text"
                      className="form-control"
                      value={editToAddress}
                      onChange={(e) => setEditToAddress(e.target.value)}
                    />
                  </span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label>
                    <span><b className="text-primary">Txn Hash</b></span>
                  </label>
                  <span className="ms-auto">
                    <input
                      type="text"
                      className="form-control"
                      value={editTxnHash}
                      onChange={(e) => setEditTxnHash(e.target.value)}
                    />
                  </span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label>
                    <span><b className="text-primary">Status</b></span>
                  </label>
                  <span className="ms-auto">
                    <select
                      className="form-control"
                      value={editStatus}
                      onChange={(e) => setEditStatus(e.target.value)}
                    >
                      <option value="open">Open</option>
                      <option value="success">Success</option>
                      <option value="failed">Failed</option>
                    </select>
                  </span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label>
                    <span><b className="text-primary">Date Time</b></span>
                  </label>
                  <span className="ms-auto">{viewData.date_time || 'N/A'}</span>
                </div>
                <span>{error}</span>
              </div>

              <div className="modal-footer">
                <button className="btn btn-primary" onClick={updateDeposit}>Save changes</button>
                <button className="btn btn-light" data-bs-dismiss="modal">Close</button>
              </div>

            </div>
          </div>
        </div>
        <ToastContainer />
      </Header>


      <Footer />

    </>
  )
}

export default Deposits